export const login = {
  subtitle: {
    verifying: 'Verifying',
    verified: 'Verified',
  },
  errors: {
    failedToSend: 'Failed to send verification code. Please try again.',
    incorrectCode: {
      title: 'Incorrect code',
      description: "The code you entered isn't correct. Please try again.",
    },
    codeExpired: {
      title: 'Code expired',
      description: 'Your verification code has expired. Please request a new one.',
    },
    verificationFailed: {
      title: 'Verification failed',
      description: 'We could not verify your code. Please try again.',
    },
    failedToResend: 'Failed to resend code. Please try again.',
    invalidPhone: 'Invalid phone number. Please check and try again.',
  },
};
